exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-4671c797] {\n  max-width: 700px;\n}\n.stop-form-modal[data-v-4671c797]  img {\n  max-height: 80vh;\n}\n", ""]);

// exports
